module.exports = __webpack_public_path__ + "static/media/header-bg.232991f5.png";